/**
 * In-memory mock API: REST client, shared stores, helpers, and asset–model seeding.
 * Used when `VITE_USE_MOCK_DATA` is enabled.
 */
import { seedAssetDerivedDataFromModels } from "./seed/asset-from-model";

seedAssetDerivedDataFromModels();

export { mockApi } from "./client/mock-client";
export type { MockApiResponse } from "./lib/types";
export * from "./lib/helpers";
export * from "./stores";
